var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile is-ancestor is-parent"},[_c('div',{staticClass:"tile is-parent is-vertical"},[_c('article',{staticClass:"tile is-child box"},[_vm._v(" Request Inspection ")])])])
}]

export { render, staticRenderFns }